import React from "react";
import * as Mui from "@mui/material";
import { StatCard } from "services/constants/designTokens";

// Grid stays owned here (not inside StatCard itself) since the column count
// is a per-screen call — Users/Companies show 3 cards (xs=12 sm=4, three
// even columns) while other screens on the same StatCard show 4 or more.
export const StatCards = ({ stats, activeFilter, onCardClick }) => (
  <Mui.Grid container spacing={2} sx={{ px: 2, pt: 1 }}>
    {stats.map((stat, index) => {
      const isCardActive =
        stat.key === "all" ? !activeFilter : activeFilter === stat.key;

      return (
        <Mui.Grid
          item
          // Two per row on phones; an odd last card spans the full row.
          xs={stats.length % 2 === 1 && index === stats.length - 1 ? 12 : 6}
          sm={4}
          key={stat.key}
        >
          <StatCard
            icon={stat.icon}
            title={stat.label}
            value={stat.count}
            detail={stat.percentLabel}
            accent={stat.fg}
            tint={stat.bg}
            isActive={isCardActive}
            onClick={onCardClick ? () => onCardClick(stat.key) : undefined}
          />
        </Mui.Grid>
      );
    })}
  </Mui.Grid>
);
